export * from './DataChartBarsXyVIcon';
export * from './DataChartBarsXyVIcon16Light';
export * from './DataChartBarsXyVIcon16Regular';
export * from './DataChartBarsXyVIcon16Solid';
export * from './DataChartBarsXyVIcon20Light';
export * from './DataChartBarsXyVIcon20Regular';
export * from './DataChartBarsXyVIcon20Solid';
export * from './DataChartBarsXyVIcon24Regular';
export * from './DataChartBarsXyVIcon24Solid';
export * from './DataChartBarsXyVIcon32Regular';
export * from './DataChartBarsXyVIcon64Regular';
